export const PORTAL_ID = "3012760";
export const INVITE_FORM_ID = "3ea288ed-991d-40ac-9c44-e6d06f4acc29";